import * as React from "react"
const SvgComponent = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M60.231 20.084a2 2 0 01.024 2.468L33.606 57.219a2 2 0 01-3.17 0L3.752 22.555a2 2 0 01.023-2.47L15.042 6h33.922L60.23 20.084zm-36.228-1.417V24h16v-5.333h-16z"
      fill="#0469C5"
    />
  </svg>
);
export default SvgComponent